class QuickAddList extends HTMLElement {
  constructor() {
    super();
    this.openOptionsButton = this.querySelector('[data-open-options]');
    this.selectedOptionEl = this.querySelector('[data-selected-option]');
    this.optionsListEl = this.querySelector('[data-options-list]');
    this.optionsButtons = this.querySelectorAll('[data-option-button]');
    this.productFormEl = this.querySelector('form');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.error = false;
    
    this.productFormEl.addEventListener('submit', this.onSubmitHandler.bind(this));
    if (this.optionsListEl) {
      this.openOptionsButton.addEventListener('click', this.toggleOptionListVisibility.bind(this));
      this.optionsButtons.forEach((button) => {
        button.addEventListener('click', this.onOptionClick.bind(this));
      });
    }
    else {
      this.openOptionsButton.addEventListener('click', this.addToCart.bind(this));
    }
  }
  set open(isOpen) {
    this.openOptionsButton.setAttribute('aria-expanded', isOpen);
    this.optionsListEl.classList.toggle('quick-add__options--open', isOpen);
    this.classList.toggle('quick-add__select--open', isOpen);
    if (isOpen) {
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    } else {
      this.removeEventListener('keydown', this.handleKeydown);
    }
  }
  get open() {
    return this.openOptionsButton.getAttribute('aria-expanded') === 'true';
  }
  handleKeydown(e) {
    if (e.key === "Escape") {
      this.open = false;
    }
  }
  async addToCart(e) {
    if(e) e.preventDefault();
    if (this.openOptionsButton.getAttribute('aria-disabled') === 'true') return;
    this.handleErrorMessage();
    this.openOptionsButton.setAttribute('aria-disabled', true);
    this.openOptionsButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.productFormEl);
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    try {
      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();
      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: data.errors || data.description,
          message: data.message,
        });
        this.handleErrorMessage(data.description);

        const soldOutMessage = this.openOptionsButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.openOptionsButton.setAttribute('aria-disabled', true);
        this.openOptionsButton.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } 
      else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error) {
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: data,
        });
        this.error = false;
      }
      this.cart.renderContents(data);
    } 
    catch (e) {
      console.error(e);
    }
    this.openOptionsButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    if (!this.error) this.openOptionsButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    this.addToCart();
  } 
  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
  toggleOptionListVisibility(e) {
    e.preventDefault();
    this.open = !this.open;
  }
  onOptionClick(e) {
    e.preventDefault();
    const selectedOptionButton = e.currentTarget.closest('button');
    const value = selectedOptionButton.dataset.value;
    const textHTMLEl = selectedOptionButton.querySelector('.quick-add__info')
    if(textHTMLEl) {
      this.openOptionsButton.querySelector('.quick-add__info').innerHTML = textHTMLEl.innerHTML;
    }
    this.optionsButtons.forEach((button) => {
      button.setAttribute('aria-selected', 'false');
    });
    selectedOptionButton.setAttribute('aria-selected', 'true');
    this.selectedOptionEl.value = value;
    this.addToCart();
    this.open = false;
  }
}
customElements.define('quick-add-list', QuickAddList);